import { string } from 'yup'
import { safify } from '../utils/safify'

export enum MediaType {
  Document = 'document',
  DocumentWithImages = 'document_with_images',
  Design = 'design',
}

export const mediaType = string()
  .required()
  .oneOf([MediaType.Document, MediaType.DocumentWithImages, MediaType.Design])
  .default(MediaType.Document)
  .meta({ label: 'What kind of content would you like?', autoFill: true })
  .transform(safify)
